export const name = "Credu Money";
export const address = "Saket Plot No./Basement Name Of floor: first floor 110034"
export const phone = "+91999911110"
export const email= "info@credumoney.in"

